<template>
  <div class="admin-categories">
    <header-title title="Grupo de Pedidos"></header-title>

    <div class="category-btn">
      <v-btn
        dense
        outlined
        :style="adminNavigationBackTheme"
        @click="openDialog()"
      >
        + Nuevo
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            outlined
            dense
            label="Buscar"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="groupOrders"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.active`]="{ item }">
            <div style="display:flex;">
              <v-switch
                v-model="item.active"
                @change="markOneGroupOrderAsActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openDialog(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-toolbar dark :color="'#9e9e9e'">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h1 class="header-tittle" :style="{ color: colorsGeneralSecondary }">
            {{
              selectedCategory
                ? "Editar Grupo de Pedido"
                : "Crear Grupo de Pedido"
            }}
          </h1>
        </v-toolbar-title>
      </v-toolbar>

      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card class="admin-categories">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader
                  :style="{ color: formLabelTheme }"
                  class="px-sm-1 px-0"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model.trim="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. Bebidas"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader
                  :style="{ color: formLabelTheme }"
                  class="px-sm-1 px-0"
                  >Grupo Activo :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-radio-group v-model="input.active" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    type="submit"
                    outlined
                    :style="adminNavigationBackTheme"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Loader from "@/components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { GroupOrderTableHeader } from "@/utils/tableHeaderconstants";
import {
  groupOrdersCollection,
  saveGroupOrder,
  updateGroupOrder
} from "@/collections/groupOrders";

// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
export default {
  name: "GroupOrders",
  components: {
    Loader,
    HeaderTitle
  },
  data() {
    return {
      search: "",
      headers: [...GroupOrderTableHeader],
      groupOrders: [],
      dialog: false,
      selectedCategory: null,
      isValid: false,
      input: {
        name: null,
        active: false
      },
      validationRules: {
        name: [v => (!!v && !!v.trim()) || "Nombre es requerido"]
      },
      dialogLoader: false
    };
  },
  firestore() {
    return {
      groupOrders: groupOrdersCollection
    };
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          if (this.selectedCategory) {
            // check update unique name
            let found = this.groupOrders.some(
              x =>
                x.name.toLowerCase().trim() ===
                  this.input.name.toLowerCase().trim() && x.id !== this.itemId
            );
            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }
            // update
            await updateGroupOrder(this.selectedCategory.id, this.buildJson());
            this.dialog = false;
          } else {
            // create
            let found = this.groupOrders.some(
              x =>
                x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim()
            );
            if (found) {
              this.showErrorMessage("El nombre debe ser único");
              return;
            }

            await saveGroupOrder(this.buildJson());
            this.dialog = false;
          }
        } catch (error) {
          this.setlogError(
            "save/update_group_order",
            "Obtained error message in submit()",
            error.stack,
            this.$options.name
          );
          this.dialog = false;
        }
      }
    },
    buildJson() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    openDialog(groupOrder) {
      this.selectedCategory = groupOrder;
      if (groupOrder) {
        this.input.name = groupOrder.name;
        this.input.active = groupOrder.active;
      }
      this.dialog = true;
    },
    closeDialog() {
      this.selectedCategory = null;
      this.$refs.form.reset();
      this.dialog = false;
    },
    async markOneGroupOrderAsActive(value, groupOrder) {
      try {
        await updateGroupOrder(groupOrder.id, { active: value });
      } catch (error) {
        this.setlogError(
          "update_group_order",
          "Obtained error message in markOneGroupOrderAsActive()",
          error.stack,
          this.$options.name
        );
      }
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>
<style scoped lang="scss">
.admin-categories {
  height: calc(100vh - 63px);
}
.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
</style>
